import React from 'react';
import Status from '../../../../../../components/Status';
import useTranslate from '../../../../../../customHooks/useTranslate';

import {
    STATUS_COLORS,
    STATUS_KEYS,
} from '../../../../utils/zitoneoServicesUtils';
import Tooltip from '../../../../../../muiComponents/Tooltip';

interface ConnectivityLogsStatusProps {
    published: boolean;
    isVisibleText: boolean;
}

const ConnectivityLogsStatus = (props: ConnectivityLogsStatusProps) => {
    const { published, isVisibleText } = props;
    const translate = useTranslate();
    const statusColor =
        STATUS_COLORS[
            (published
                ? STATUS_KEYS.PUBLISHED
                : STATUS_KEYS.NOT_STARTED) as keyof typeof STATUS_COLORS
        ];
    const statusText = isVisibleText
        ? translate(published ? 'transmitting' : 'not_connected')
        : '';

    return (
        <Tooltip
            hideTooltip={isVisibleText}
            titleText={published ? 'transmitting' : 'not_connected'}
        >
            <span>
                <Status text={statusText} color={statusColor} />
            </span>
        </Tooltip>
    );
};

export default ConnectivityLogsStatus;
